import { ICartEntry } from '@rbi-ctg/menu';
import { routes } from 'utils/routing';

import { CartEntryType } from './types';

export const isCartEntryItem = (cartEntry: ICartEntry) => cartEntry.type === CartEntryType.item;

export const isCartEntryCombo = (cartEntry: ICartEntry) => cartEntry.type === CartEntryType.combo;

export const isCartEntryItemOption = (cartEntry: ICartEntry) =>
  cartEntry.type === CartEntryType.itemOption;

export const isCartEntryComboSlot = (cartEntry: ICartEntry) =>
  cartEntry.type === CartEntryType.comboSlot;

export const isCartEntryPicker = (pathname: string) =>
  new RegExp(`^${routes.menu}/picker`).test(pathname);
